import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import 'moment/locale/fr';

const MyDialog = (props) => {
  const { open, handleClose, title, content, dialog } = props;

  const handleReturn = (value) => {
    dialog(value);
    handleClose(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleReturn(false)} color="primary"> Annuler </Button>
          <Button onClick={() => handleReturn(true)} color="primary"> Valider </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MyDialog;